import React, { memo } from 'react';

function PowerUpBar({ powerUps, powerUpMode, onUndo, onBomb, onRefresh, disabled, canUndo }) {
  return (
    <div className="power-up-bar">
      <button
        className={`power-up-btn power-up-undo${!canUndo || powerUps.undo <= 0 ? ' power-up-disabled' : ''}`}
        onClick={onUndo}
        disabled={disabled || !canUndo || powerUps.undo <= 0}
        aria-label={`Undo (${powerUps.undo} remaining)`}
      >
        <span className="power-up-icon">&#8634;</span>
        <span className="power-up-label">Undo</span>
        {powerUps.undo > 0 && <span className="power-up-count">{powerUps.undo}</span>}
      </button>

      <button
        className={`power-up-btn power-up-bomb${powerUpMode === 'bomb' ? ' power-up-active' : ''}${powerUps.bomb <= 0 ? ' power-up-disabled' : ''}`}
        onClick={onBomb}
        disabled={disabled || powerUps.bomb <= 0}
        aria-label={`Bomb (${powerUps.bomb} remaining)`}
      >
        <span className="power-up-icon">&#128163;</span>
        <span className="power-up-label">Bomb</span>
        {powerUps.bomb > 0 && <span className="power-up-count">{powerUps.bomb}</span>}
      </button>

      <button
        className={`power-up-btn power-up-refresh${powerUps.refresh <= 0 ? ' power-up-disabled' : ''}`}
        onClick={onRefresh}
        disabled={disabled || powerUps.refresh <= 0}
        aria-label={`Refresh pieces (${powerUps.refresh} remaining)`}
      >
        <span className="power-up-icon">&#8635;</span>
        <span className="power-up-label">Refresh</span>
        {powerUps.refresh > 0 && <span className="power-up-count">{powerUps.refresh}</span>}
      </button>
    </div>
  );
}

export default memo(PowerUpBar);
